const Faq = () => {
    return (
        <p>Pogosta vprašanja</p>
    )
}


export default Faq;